/** Parent_delegate report-templates — parent session, both ids in path. */

export function parentChildReportTemplatesBasePath(
  parentAccountId: string | number,
  childAccountId: string | number,
): string {
  return `/authenticated/client/${parentAccountId}/analytics/children/${childAccountId}/report-templates`;
}

export function parentChildReportTemplatesListPath(
  parentAccountId: string | number,
  childAccountId: string | number,
): string {
  return parentChildReportTemplatesBasePath(parentAccountId, childAccountId);
}

export function parentChildReportTemplatesAssignPath(
  parentAccountId: string | number,
  childAccountId: string | number,
): string {
  return `${parentChildReportTemplatesBasePath(parentAccountId, childAccountId)}/assign`;
}

export function parentChildReportTemplatesUnassignPath(
  parentAccountId: string | number,
  childAccountId: string | number,
): string {
  return `${parentChildReportTemplatesBasePath(parentAccountId, childAccountId)}/unassign`;
}
